// Shared react-select styling for the goals forms so dropdowns match the
// height/border of the SuiInput fields next to them.
const goalSelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 40,
    borderRadius: 8,
    borderColor: state.isFocused ? "#17c1e8" : "#d2d6da",
    boxShadow: state.isFocused ? "0 0 0 2px rgba(23, 193, 232, 0.25)" : "none",
    cursor: "pointer",
    "&:hover": { borderColor: state.isFocused ? "#17c1e8" : "#d2d6da" },
  }),
  valueContainer: (base) => ({ ...base, padding: "0 12px" }),
  placeholder: (base) => ({ ...base, color: "#8392ab", fontSize: 14 }),
  singleValue: (base) => ({ ...base, color: "#495057", fontSize: 14 }),
  input: (base) => ({ ...base, color: "#495057", fontSize: 14, margin: 0, padding: 0 }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (base) => ({ ...base, color: "#8392ab" }),
  menu: (base) => ({ ...base, borderRadius: 8, overflow: "hidden", zIndex: 5 }),
  menuPortal: (base) => ({ ...base, zIndex: 1500 }),
  option: (base, state) => ({
    ...base,
    fontSize: 14,
    cursor: "pointer",
    color: state.isSelected ? "#fff" : "#495057",
    backgroundColor: state.isSelected ? "#17c1e8" : state.isFocused ? "#e9f8fc" : "#fff",
  }),
};

export default goalSelectStyles;
